function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-warningicon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "26-desktop-UI-warningicon",
  transform: "translate(-134.000000, -631.000000)"
}, React.createElement("g", {
  id: "icon-warningicon",
  transform: "translate(134.000000, 631.000000)"
}, React.createElement("g", {
  id: "Icon-warningicon"
}, React.createElement("path", {
  d: "M21,42 C32.5979797,42 42,32.5979797 42,21 C42,9.40202025 32.5979797,0 21,0 C9.40202025,0 0,9.40202025 0,21 C0,32.5979797 9.40202025,42 21,42 Z",
  id: "Oval-warningicon",
  fill: "#FECB1C"
}), React.createElement("path", {
  d: "M22.0246377,24.27 L19.9043478,24.27 L19.6710145,14 L22.2681159,14 L22.0246377,24.27 Z M19.6,27.41 C19.6,27.0299981 19.7251195,26.7150013 19.9753623,26.465 C20.2256051,26.2149988 20.5671476,26.09 21,26.09 C21.4328524,26.09 21.7743949,26.2149988 22.0246377,26.465 C22.2748805,26.7150013 22.4,27.0299981 22.4,27.41 C22.4,27.7766685 22.2782621,28.0833321 22.0347826,28.33 C21.7913031,28.5766679 21.446379,28.7 21,28.7 C20.553621,28.7 20.2086969,28.5766679 19.9652174,28.33 C19.7217379,28.0833321 19.6,27.7766685 19.6,27.41 L19.6,27.41 Z",
  fill: "#FFFFFF"
})))));

var SvgWarningIcon = function SvgWarningIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warningIcon.39d23edf.svg";
export { ForwardRef as ReactComponent };